<template>
  <BaseButton
    tag="button"
    type="button"
    class="modal-button sync-calendar-modal-button fs-12 fw-500 color-blue"
    :icon="icon"
    aria-controls="sync-calendar-modal"
    :aria-pressed="String(showSyncCalendarModal)"
    v-bind="$attrs"
    v-on="$listeners"
    @click="onClick"
  >
    <slot />
  </BaseButton>
</template>

<script>
export default {
  name: 'SyncCalendarButton',
  inheritAttrs: false,
  props: {
    /** @type {import('vue/types/options').PropOptions<string | null | undefined>} */
    icon: {
      type: String,
      default: 'synchronize',
    },
  },
  computed: {
    showSyncCalendarModal: {
      /**
       * @returns {boolean}
       */
      get() {
        return !!this.$store.getters['calendar/showSyncCalendarModal'];
      },
      /**
       * @param {boolean} value
       */
      set(value) {
        if ((value = !!value) !== this.$store.getters['calendar/showSyncCalendarModal']) {
          this.$store.commit('calendar/setShowSyncCalendarModal', value);
        }
      },
    },
  },
  methods: {
    /**
     * @returns {void}
     */
    onClick() {
      this.showSyncCalendarModal = true;
    },
  },
};
</script>
